<template>
  <div>
    <!-- 顶部导航 -->
    <TopNav></TopNav>
    <!-- 物联网平台轮播图 -->
    <ThingsBanner></ThingsBanner>
    <!-- 物联子系统 -->
    <IOT></IOT>
    <!-- 应用场景 -->
    <Application></Application>
    <!-- 底部导航 -->
    <ButtonNav></ButtonNav>
  </div>
</template>

<script>
import { reactive } from "vue";

import TopNav from "../../../../components/pc/components/TopNav.vue";
import ButtonNav from "../../../../components/pc/components/BottomNav.vue";
import ThingsBanner from '../../../../components/pc/Product/ThingsComponents/ThingsBanner.vue'
import IOT from '../../../../components/pc/Product/ThingsComponents/IOT.vue'
import Application from '../../../../components/pc/Product/ThingsComponents/Application.vue'

export default {
  setup() {
    return reactive({});
  },
  components: {
    TopNav,
    ButtonNav,
    ThingsBanner,
    IOT,
    Application
  },
};
</script>

<style scoped>
</style>
